import { render, staticRenderFns } from "./StockInventoryLines.vue?vue&type=template&id=0206bfba&"
import script from "./StockInventoryLines.vue?vue&type=script&lang=js&"
export * from "./StockInventoryLines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports